import { Component, inject } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
    selector: "wk-add-edit",
    templateUrl: "add-edit.component.html",
    styleUrl: "./add-edit.component.scss",
    standalone: false,
    host: {
        class: "wk-add-edit",
    },
})
export class AddEditComponent {
    bsModalRef = inject(BsModalRef);

    data: any;
    initialColumn: any;
    title: string;
    callback: (column: any) => void;

    constructor() {}

    submitForm() {
        if (this.data.Name["en-CA"].trim() !== "" && this.data.Name["fr-CA"].trim() !== "") {
            this.callback(this.data);
            this.bsModalRef.hide();
        }
    }
}
